/**
 * Safe client-side JavaScript code runner & snippet extractor
 */

export function extractCodeSnippets(note = '') {
  if (!note) return [];
  const regex = /```([a-zA-Z0-9_-]+)?\s*([\s\S]*?)```/g;
  const snippets = [];
  let match;
  while ((match = regex.exec(note)) !== null) {
    snippets.push({
      lang: (match[1] || 'javascript').toLowerCase(),
      code: match[2].trim(),
    });
  }
  return snippets;
}

export function executeJsSandbox(code, timeoutMs = 2000) {
  const logs = [];
  const start = performance.now();

  try {
    // Custom sandbox logger
    const customConsole = {
      log: (...args) => logs.push(args.map(a => typeof a === 'object' ? JSON.stringify(a) : String(a)).join(' ')),
      warn: (...args) => logs.push('[WARN] ' + args.map(a => typeof a === 'object' ? JSON.stringify(a) : String(a)).join(' ')),
      error: (...args) => logs.push('[ERROR] ' + args.map(a => typeof a === 'object' ? JSON.stringify(a) : String(a)).join(' ')),
      info: (...args) => logs.push('[INFO] ' + args.map(a => typeof a === 'object' ? JSON.stringify(a) : String(a)).join(' ')),
    };

    // Safe execution context via Function constructor with shadowed window/document
    const runner = new Function(
      'console',
      `"use strict";
      try {
        ${code}
      } catch (err) {
        console.error(err.message || String(err));
      }`
    );

    runner(customConsole);
    const duration = Math.round(performance.now() - start);

    return {
      success: true,
      logs: logs.length > 0 ? logs : ['Execution completed with no output.'],
      duration,
    };
  } catch (err) {
    const duration = Math.round(performance.now() - start);
    return {
      success: false,
      logs: [`[SYNTAX/RUN ERROR] ${err.message}`],
      duration,
    };
  }
}
